import { Container, Row, Col, Button } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import styled from "styled-components"

import Navigation from '../components/Layout/Navigation';
import Footer from '../components/Layout/Footer';

import '../components/GlobalStyle.css';

import CircleBG3 from '../assets/images/Circle BG 3.png';

import GraphIcon from '../assets/icons/BPS Icon - Graph.png';
import CustomIcon from '../assets/icons/BPS Icon - Custom.png';
import TargetIcon from '../assets/icons/BPS Icon - Target.png';

import { CTA } from '../components/Layout/CTA';
import { FadeLoad, FadeScroll } from '../components/styled/Motion.styled';
import { StaffCards } from '../components/AboutComponents/StaffCards';



const About = () => {
    return (
        <>
            <Helmet>
                <meta charSet="utf-8" />
                <title>Resources | About</title>
                <link rel="canonical" href="https://bestpayment.solutions/about" />
            </Helmet>
            <Navigation />
            <Container fluid className='vh-75 circle-bg-7-scroll'>
                <Row className='pt-5 justify-content-evenly text-center'>
                    <Col lg={7}>
                        <FadeLoad>
                            <h2 className='fw-bold fs-24 color-sky-tint-1'>About Best Payment Solutions</h2>
                            <h1 className='fs-48'>
                                Every incentive solution is a testament to innovation, excellence, & transparency
                            </h1>
                            <p>
                                With over 20 years of experience, our team is dedicated to providing the best solutions for our clients. We work with everyone from smaller brands, to Fortune 500 companies, to municipalities with strict budgets. Partnering with our dedicated team of technology, payment, and fulfillment experts means more of your spending will go directly toward programs that move the needle for your business.
                            </p>
                        </FadeLoad>
                    </Col>
                </Row>
            </Container >
            <Container fluid className='vh-50 py-5 circle-bg-6-scroll'>
                <Row className='align-items-center'>
                    <Col lg={5} md={6} className='offset-lg-5 offset-md-4'>
                        <FadeScroll>
                            <p className='fs-24 fw-800 color-midnight fw-bold'>
                                Our team is always looking for ways to improve our services and build stronger relationships with our clients. We want to partner with you to find the solutions that best fit your needs.
                            </p>
                        </FadeScroll>
                    </Col>
                </Row>
            </Container>
            <Container fluid className='vh-50 bg-cream py-5'>
                <Row className='pt-5'>
                    <Col>
                        <FadeScroll>
                            <h5 className='fs-48 fw-900 color-midnight text-center'>Driven by purpose. Powered by principle.</h5>
                        </FadeScroll>
                    </Col>
                </Row>
                <Row className="justify-content-evenly py-5">
                    <Col xxl={3} md={3} className='py-2 py-md-5'>
                        {/* <img src={GraphIcon} width={60} /> */}
                        <h4 className='fs-20 pt-4'>Vision</h4>
                        <p>
                            Build an iconic, multi-million-dollar, consumer-first company that challenges the status quo while  never compromising our work-life balance for our team.
                        </p>
                    </Col>
                    <Col xxl={3} md={3} className='py-2 py-md-5'>
                        {/* <img src={CustomIcon} width={60} /> */}
                        <h4 className='fs-20 pt-4'>Mission</h4>
                        <p>
                            Build purpose-driven programs that increase our client’s revenue, and provide the best-in-class customer service while utilizing the latest in technology that supports our clients and internal staff.
                        </p>
                    </Col>
                    <Col xxl={3} md={3} className='py-2 py-md-5'>
                        {/* <img src={TargetIcon} width={60} /> */}
                        <h4 className='fs-20 pt-4'>Values</h4>
                        <p>
                            Radical Transparency, Doing the right thing, and Conscientiousness alongside financial gain that supports all our staff.
                        </p>
                    </Col>
                </Row>
            </Container>
            <Container fluid className='py-5'>
                <Row className="justify-content-evenly align-items-center py-5 text-center">
                    <Col lg={6}>
                        <h5 className='fs-48'>Meet our experts</h5>
                        <p>
                            The Best Payment Solutions team is composed of industry experts who are passionate about their work, have excelled in their field, and have an extensive background in a wide variety of applications. We deliver a full range of skill sets to meet your needs up and down the stack. These include strategic incentive program development, web designers, project management professionals (PMP), and tactical specialists.
                        </p>
                    </Col>
                </Row>
                <Row className="justify-content-evenly align-items-center py-5">
                    <Col lg={12}>
                        <StaffCards />
                    </Col>
                </Row>
            </Container>
            <Container fluid className='bg-sky-tint-3 py-5'>
                <CTA />
            </Container>
            <Footer />
        </>
    );
}

export default About;